import { render, staticRenderFns } from "./TaxRateManage.vue?vue&type=template&id=c2068d3a&scoped=true"
import script from "./TaxRateManage.vue?vue&type=script&lang=js"
export * from "./TaxRateManage.vue?vue&type=script&lang=js"
import style0 from "./TaxRateManage.vue?vue&type=style&index=0&id=c2068d3a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2068d3a",
  null
  
)

export default component.exports